// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","985":"component---src-pages-privacy-tsx"}[chunkId] + "-" + {"245":"bb7e3aa5724f7dee9b7a","985":"3160fdd2216e0fb310c3"}[chunkId] + ".js";
};